export default __webpack_public_path__ + "static/media/imagePopupHorizontal.4238a33d.png";